// Tally sometimes stores an option's internal ID instead of its name (options
// added later, or shown by conditional logic), and some options were renamed
// on the form. This maps both back to one canonical name per option, so the
// timeline, journal, briefs and community counts all agree.
//
// Source: Tally form b59467 ("Crisis Tracker"), read 2026-10-01. Canonical
// names are the ones already used in stored data.

const PAIN_LOCATION = {
  "e7e9a60e-2f63-494c-9cd7-6e6a8e3ec2ff": "Arms",
  "a7497235-26d4-4402-98d2-81cfb55cfa4d": "Back",
  "18adaa64-ee3d-43f0-9dbb-b8eebf4235e1": "Abdomen",
  "abff3e64-1c7c-4357-a16e-49c5a54318ef": "Chest",
  "5915f704-dc3b-4d3a-a829-73bc5d40c5e6": "Feet",
  "550bd6f6-0197-4d51-adf0-de13722e4d3a": "Fingers / Hands",
  "b68a0b6e-d339-444b-a4da-931a6035051d": "Head",
  "92f05b77-fdde-44ef-88be-fdbe684ac133": "Hips",
  "890766d8-10de-4709-bfdf-0599ed325dd6": "Joints",
  "Joints (general)": "Joints",
  "391b7d91-e84e-450d-b040-1492acd2d930": "Legs",
  "b4133181-9f5d-4045-a7a7-cad24188bf52": "Mouth / Teeth",
  "953ae06c-8ba4-4240-8a84-10c9f75f07f5": "Neck",
  "62051e7c-72c4-43ab-9bb5-c99d3e1ffc70": "Pelvis",
  "c25f9614-1038-4500-8631-94add6ec0142": "Priapism",
  "87b388fc-9d14-48b3-be0d-f4f7e1c52d94": "Ribs",
  "9c562c45-f7b0-463b-b6b8-5976ebe60fb7": "Other",
};

const TRIGGER = {
  "be1a48a0-22ac-4dd6-839e-73b06559c431": "Cold weather exposure",
  "53121ca9-c265-42c0-a972-6b78ea49a7f0": "High stress situation",
  "f6cbba0f-e542-4866-b789-21b1acdd991a": "Lack of sleep",
  "a7b2275f-eaac-40dc-96e0-a48f593a4553": "Dehydration (missed water intake)",
  "Dehydration": "Dehydration (missed water intake)",
  "ca54072d-f23f-484c-90e4-6e98e5c3b3f1": "Physical overexertion",
  "53301ff5-2425-4549-81f7-10d2888f150b": "Illness (cold, flu, infection)",
  "Illness or infection": "Illness (cold, flu, infection)",
  "20a413a3-23ed-44b5-b6cb-8120ce2b328a": "Skipped medication",
  "78b8c227-96bb-4cfe-aca6-319ba8558512": "Changed altitude/air pressure",
  "Changed altitude or air pressure": "Changed altitude/air pressure",
  "eb238060-0422-4269-a8cf-4277ab4c060e": "Temperature or weather change",
  "a5c74e9c-95f1-407e-9300-9461cb41b708": "Sex",
  "Sexual activity": "Sex",
  "2f5d8956-e028-4cd0-924d-4274a5154cdf": "Menstrual cycle",
  "Menstrual Cycle": "Menstrual cycle",
  "709a8650-422c-4634-aae8-6ab08017cfc6": "Other",
};

const TREATMENT = {
  "beab4cde-f8a2-413b-bbfa-11d4a07dba4b": "Prescription pain medication",
  "4af5c1bc-097d-4fbb-9a69-d570d11defe1": "Over-the-counter pain relief",
  "77eeca03-e71f-4de7-b122-946adf2b4814": "Heating pad",
  "8af7bdff-4e46-450f-ae4b-dd2d2aa0fc2b": "Hydration",
  "85eb661b-e008-4bed-b107-107dd8a99552": "Rest",
  "2f439928-b09a-42d0-8a27-395e3032844b": "Breathing exercises",
  "6aac4451-384a-4afb-8285-f3b153eddff8": "Oxygen therapy",
  "Oxygen": "Oxygen therapy",
  "e5d20c98-d3bf-45cc-a15e-43196dc481e6": "Fluids",
  "48f4d3fe-8616-421c-9cc4-0a1f9036d08e": "Nothing is helping yet",
};

const TABLES = { painLocations: PAIN_LOCATION, triggered: TRIGGER, treatment: TREATMENT };
const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

// Canonical names for one multi-select field. Unknown option IDs are dropped
// (they mean nothing to a reader); everything else passes through unchanged
// and later display layers decide what may be shown.
export function normalizeOptions(field, values) {
  const table = TABLES[field] || {};
  const out = [];
  (values || []).forEach((v) => {
    const s = String(v || "").trim();
    if (!s) return;
    const mapped = Object.prototype.hasOwnProperty.call(table, s) ? table[s] : s;
    if (UUID.test(mapped)) return;
    if (!out.includes(mapped)) out.push(mapped);
  });
  return out;
}

export const FORM_OPTION_TABLES = TABLES;
